import React, {useState, useEffect, useCallback} from 'react';
import styled from "styled-components";
import {StyledForeground} from "../Components/Commons/StyledForeground.react";
import TBSearch from "../Components/Commons/Search.react";
import TransactionSwitch from "../Components/ReconcileTransactions/TransactionSwitch.react";
import TBDateRangePicker from "../Components/Commons/Dates/TBDateRangePicker.react";
import FiltersModal from "../Components/Commons/FiltersModal.react";
import ExportButton from "../Components/Commons/Buttons/ExportButton.react";
import Pagination from "../Components/Commons/Pagination.react";
import {Table} from "react-materialize";
import UnreconciledTransactions
  from "../Components/ReconcileTransactions/Unreconciled/UnreconciledTransactions.react";
import ReconciledTransactions from "../Components/ReconcileTransactions/Reconciled/ReconciledTransactions.react";
import useFetch from "../Utilities/API/useFetch.react";

const StyledReconcilePage = styled.div`
  margin-top: 10rem;
  padding-left: 3rem;
  padding-right: 3rem;
  
  .header {
    display: flex;
    justify-content: space-between;
  }
  
  .tab-selection {
    display: flex;
  }
  
  .subheader {
    display: flex;
    justify-content: space-between;
    margin-top: 5rem;
  }
  
  .content-container {
    border: 1px solid #E4E6E7;
    margin: 1rem 0 1rem 0;
    
    thead {
      background-color: white;
    }
    
    td:first-of-type, th:first-of-type {
      padding-left: 2rem;
    }
    
    td:last-of-type, th:last-of-type {
      padding-right: 2rem;
    }
    
    th {
      text-align: left;
      border-radius: 0px;
    }
    
    td {
      text-align: left;
    }
  }
`

export const RECONCILE_TYPES = { UNRECONCILED: {value: 'UNRECONCILED', label: 'Unreconciled'}, RECONCILED: {value: 'RECONCILED', label: 'Reconciled'}};

const ReconcileTransactionsPage = () => {
  const [reconcileType, setType] = useState(RECONCILE_TYPES.UNRECONCILED);
  const [loading, setLoading] = useState(true);
  const [unreconciledTransactions, setUnreconiledTransactions] = useState([]);
  const [reconciledTransactions, setReconciledTransactions] = useState([]);
  const [pageTotal, setPageTotal] = useState(1);
  const [page, setPage] = useState(1);
  const [paginationCount, setPaginationCount] = useState({start: 0, end: 0, pageTotal: 0});

  const [fetchUrl] = useFetch();

  const getUnreconciledTransactions = async () => {
    let transactionsList = await fetchUrl('fetchUnreconciledTransactions');
    if (transactionsList.length > 0) {
      setPaginationCount({start: 1, end: transactionsList.length, total: transactionsList.length})
    }

    setUnreconiledTransactions(transactionsList);
    setLoading(false);
  }

  useEffect( () => {
    getUnreconciledTransactions()
  }, [])

  const handlePagination = () => {
    console.log('clicked')
  }

  return (
    <StyledReconcilePage>
      <StyledForeground foreGroundHeight={'30.5rem;'}/>
      <div className={'header'}>
        <TransactionSwitch type={reconcileType} setType={setType} />
        <TBSearch darkMode={true} />
      </div>
      <div className={'subheader'}>
        <div className={'filter-section'}>
          <TBDateRangePicker />
        </div>
        <div>
          <ExportButton darkMode={true} />
        </div>
      </div>
      {/*<UnreconciledTransactions transactions={unreconciledTransactions} loading={loading} />*/}
      {reconcileType.value == 'UNRECONCILED' ? <UnreconciledTransactions transactions={unreconciledTransactions} loading={loading} /> : <ReconciledTransactions />}
      <Pagination
        handleClick={handlePagination}
        total={paginationCount.total}
        page={page}
        count={paginationCount}
        pages={pageTotal}
        perPage={'10'}
        label={'Transactions'}
      />
    </StyledReconcilePage>
  )
}

export default ReconcileTransactionsPage;